import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { errMsg } from "./useCrm";

/** Admin-team roster (invite / resend / remove other admins). */
export default function useAdminTeam(api, enabled) {
  const [admins, setAdmins] = useState([]);

  const load = useCallback(async () => {
    if (!enabled) return;
    try { setAdmins((await api.get("/admins")).data); } catch (e) { if (e.response?.status !== 401) toast.error("Could not load admins."); }
  }, [api, enabled]);

  useEffect(() => { load(); }, [load]);

  const addAdmin = async (payload) => {
    try {
      const { data } = await api.post("/admins", payload);
      setAdmins((prev) => [...prev, data]);
      toast.success(data.invite_sent ? `${data.name} invited — e-mail sent` : `${data.name} added as admin`);
      return data;
    } catch (e) { toast.error(errMsg(e, "Could not invite admin.")); return null; }
  };

  const inviteAdmin = async (admin) => {
    try {
      const { data } = await api.post(`/admins/${admin.id}/invite`);
      setAdmins((prev) => prev.map((a) => (a.id === admin.id ? { ...a, login_status: "invited" } : a)));
      if (data.invite_sent) toast.success(`Invite e-mail sent to ${admin.email}`);
      return data;
    } catch (e) { toast.error(errMsg(e, "Could not send invite.")); return null; }
  };

  const removeAdmin = async (admin) => {
    try {
      await api.delete(`/admins/${admin.id}`);
      setAdmins((prev) => prev.filter((a) => a.id !== admin.id));
      toast.success(`${admin.name} removed from admins`);
    } catch (e) { toast.error(errMsg(e, "Could not remove admin.")); }
  };

  return { admins, addAdmin, inviteAdmin, removeAdmin };
}
